import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Typography } from '@mui/material';

const MS_IN_MINUTE = 60 * 1000;

const CoachTimeClock = ({ timeZone }) => {
  const [now, setNow] = useState(() => moment());

  useEffect(() => {
    let timeoutId;
    function scheduleNext() {
      const msUntilNextMinute = MS_IN_MINUTE - (Date.now() % MS_IN_MINUTE);
      timeoutId = setTimeout(() => {
        setNow(moment());
        scheduleNext();
      }, msUntilNextMinute);
    }
    scheduleNext();
    return () => clearTimeout(timeoutId);
  }, []);

  const { label, title } = useMemo(() => {
    const isValidTimeZone = !!timeZone && !!moment.tz.zone(timeZone);
    const timeMoment = isValidTimeZone ? moment(now).tz(timeZone) : moment(now);
    const timeText = timeMoment.format('h:mm A');
    const tzAbbreviation = isValidTimeZone ? timeMoment.format('z') : '';

    return {
      label: tzAbbreviation ? `${timeText} ${tzAbbreviation}` : timeText,
      title: isValidTimeZone ? `Coach time (${timeZone})` : 'Coach time',
    };
  }, [now, timeZone]);

  return (
    <Typography
      title={title}
    >
      {label}
    </Typography>
  );
};

CoachTimeClock.propTypes = {
  timeZone: PropTypes.string,
};

CoachTimeClock.defaultProps = {
  timeZone: '',
};

export default CoachTimeClock;
